/**
 * 可编辑表格单元格类
 * @param {*} value 单元格值，一般为string，当 type = gridselect 时，value 应设置为 array
 * @param {string} type 单元格类型。默认值：text
 *    @field text 单纯文本单元格
 *    @field textedit 可编辑文本单元格
 *    @field texteditarr 多个可编辑文本单元格
 *    @field textarea 可编辑文本域单元格
 *    @field datepicker 日历单元格
 *    @field imageshow 可上传的图片展示单元格
 *    @field mergegrid 横杠占位单元格
 *    @field rank 等第评价单元格
 *    @field gridselect 选择下拉
 * @param {boolean} canEdit 单元格是否可编辑。默认值：false
 * @param {boolean} editType 单元格编辑功能显示状态。默认值：false
 * @param {*} editValue 单元格编辑值，不用设置，默认设置editValue = value。提交之前的修改操作只是对编辑值进行操作
 * @param {string} imageTip 图片单元格打底文字，type='imageshow'时有效。默认值：null
 * @param {string} rankName 用于设置等第评价单元格的 单选组件分组name属性，type='rank'时有效。默认值：null
 * @param {number} x 单元格x轴占位个数。默认值：1
 * @param {number} y 单元格y轴占位个数。默认值：1
 * @param {object} style 单元格自定义css样式
 * @param {function} proving 可编辑值的校验规则（input事件触发）
 * @param {function} provingBlur 可编辑值的校验规则（blur事件触发）
 * @param {boolean} dnf 是否在输入框触发bulr事件时进行默认的数字类型格式化
 * @param {array} options 下拉框配置对象，当type = gridselect 时才需要设置
 * @param {array} placeholders 输入框提示文字，当type = texteditarr 时才需要设置
 */
class Grid {
  constructor ({
    value,
    type = 'text',
    canEdit = false,
    editType = false,
    editValue,
    imageTip = null,
    rankName = null,
    x = 1,
    y = 1,
    style = {},
    proving = null,
    provingBlur = null,
    dnf = false,
    options = null,
    placeholders = null,
    canEmpty = true
  }) {
    this.value = value
    this.type = type
    this.editType = editType
    this.canEdit = canEdit
    this.editValue = Array.isArray(value)
      ? JSON.parse(JSON.stringify(value))
      : value
    this.x = x
    this.y = y
    this.style = style
    this.imageTip = imageTip
    this.rankName = rankName
    this.proving = proving
    this.provingBlur = provingBlur
    this.noCheckError = true
    this.dnf = dnf
    this.options = options
    this.placeholders = placeholders
    this.canEmpty = canEmpty
  }
  /**
   * 设置单元格编辑值函数
   */
  setEditValue = function (editValue) {
    this.editValue = editValue
  }
  /**
   * 重置单元格编辑值函数
   */
  resetEditValue = function () {
    this.editValue = this.value
  }
  /**
   * 设置单元格值函数
   */
  uploadValue = function () {
    this.value = this.editValue
  }

  /**
   * 设置单元格可编辑状态
   */
  setEditType = function (editType) {
    if (this.canEdit) this.editType = editType
  }
}

/**
 * 学籍卡类
 * @param row 表格最大可拆分的行数，不需手动设置
 * @param column 表格最大可拆分的列数，不需手动设置
 * @param tableData 表格结构描述及数据存储数组
 * @param httpData {*} 数据接口返回的原始数据，用于卡片编辑保存功能
 * @param updateHttpData {function} 卡片编辑保存函数，函数返回值必须是promise
 */
export default class StatusCard {
  constructor (
    tableData,
    title,
    res = null,
    updateHttpData = null,
    canEdit = true,
    editType = false
  ) {
    let row = 0
    let column = 0
    this.tableData = tableData.map((sub, i) => {
      if (Array.isArray(sub)) {
        return sub.map((item, j) => {
          if (editType && item.canEdit) item.editType = true
          const grid = new Grid(item)
          if (i === 0) column += grid.x
          if (j === 0) row++
          return grid
        })
      } else {
        return []
      }
    })
    this.row = row
    this.column = column
    this.title = title
    this.editType = editType
    this.httpData = res
    this.updateHttpData = updateHttpData
    this.loading = false
    this.canEdit = canEdit
  }
  setLoading (loading) {
    this.loading = loading
  }
  /**
   * @function 当学籍卡对象已创建后，使用此方法更新学籍卡对象内容
   * @param {array} 单元格配置对象
   */
  updateTableData (arr2) {
    const text = ['text', 'mergegrid']
    for (let i = 0; i < this.tableData.length; i++) {
      const row = this.tableData[i]
      for (let j = 0; j < row.length; j++) {
        const column = row[j]
        if (!text.includes(column.type)) {
          column.editValue = column.value = arr2[i][j].value
          column.editType = false
        }
      }
    }
  }
  /**
   * 所有单元格编辑状态设置方法
   * @param {*} editType 单元格编辑状态
   */
  setEditTypeAll = function (editType) {
    this.editType = editType
    this.tableData.forEach(d1 => {
      d1.forEach(d2 => {
        d2.setEditType(editType)
      })
    })
  }

  /**
   * 重置所有单元格编辑值函数
   */
  resetEditValueAll = function () {
    this.tableData.forEach(d1 => {
      d1.forEach(d2 => {
        d2.resetEditValue()
      })
    })
  }

  /**
   * 设置所有单元格值函数
   */
  uploadValueAll = function () {
    this.tableData.forEach(d1 => {
      d1.forEach(d2 => {
        d2.uploadValue()
      })
    })
  }

  /**
   * @method 获取体制数据加分项、基础项各项
   * @description 根据年级、性别生成体质数据各项参数
   * @param {number} grade 年级id
   * @param {number} gender 性别code 1：男 2： 女
   */
  static queryTableColumns (grade, gender) {
    const localColumns = [
      {
        label: '学年得分',
        value: 'totalScore',
        'min-width': 100
      },
      {
        label: '基础项目',
        children: [
          {
            label: '体重指数（千克/平方米）',
            value: 'bodyMassIndex'
          },
          {
            label: '肺活量（毫升）',
            value: 'vitalCapacity'
          },
          {
            label: '50米跑（秒）',
            value: 'meterRun50'
          },
          {
            label: '坐位体前屈（厘米）',
            value: 'sitAndReach'
          }
        ]
      },
      {
        label: '加分项',
        children: []
      }
    ]
    switch (grade) {
      case 1:
      case 2:
        localColumns.filter(c => {
          if (c.label === '基础项目') {
            c.children.push({
              label: '一分钟跳绳（次）',
              value: 'ropeSkipping'
            })
          }
          if (c.label === '加分项') {
            c.children.push({
              label: '一分钟跳绳（次）',
              value: 'ropeSkipping'
            })
          }
        })
        break
      case 3:
      case 4:
        localColumns.filter(c => {
          if (c.label === '基础项目') {
            c.children.push(
              {
                label: '一分钟跳绳（次）',
                value: 'ropeSkipping'
              },
              {
                label: '一分钟仰卧起坐（次）',
                value: 'abdominalCurl'
              }
            )
          }
          if (c.label === '加分项') {
            c.children.push({
              label: '一分钟跳绳（次）',
              value: 'ropeSkipping'
            })
          }
        })
        break
      case 5:
      case 6:
        localColumns.filter(c => {
          if (c.label === '基础项目') {
            c.children.push(
              {
                label: '一分钟跳绳（次）',
                value: 'ropeSkipping'
              },
              {
                label: '一分钟仰卧起坐（次）',
                value: 'abdominalCurl'
              },
              {
                label: '50米×8往返跑（分·秒）',
                value: 'meterRun400'
              }
            )
          }
          if (c.label === '加分项') {
            c.children.push({
              label: '一分钟跳绳（次）',
              value: 'ropeSkipping'
            })
          }
        })
        break
      default:
        localColumns.filter(c => {
          if (c.label === '基础项目') {
            if (gender === 1) {
              c.children.push(
                {
                  label: '引体向上（次）',
                  value: 'pullUp'
                },
                {
                  label: '1000米跑（分·秒）',
                  value: 'meterRun1000'
                }
              )
            } else {
              c.children.push(
                {
                  label: '一分钟仰卧起坐（次）',
                  value: 'abdominalCurl'
                },
                {
                  label: '800米跑（分·秒）',
                  value: 'meterRun800'
                }
              )
            }
            c.children.push({
              label: '立定跳远（厘米）',
              value: 'standingLongJump'
            })
          }
          if (c.label === '加分项') {
            if (gender === 1) {
              c.children.push(
                {
                  label: '引体向上（次）',
                  value: 'pullUp'
                },
                {
                  label: '1000米跑（分·秒）',
                  value: 'meterRun1000'
                }
              )
            } else {
              c.children.push(
                {
                  label: '一分钟仰卧起坐（次）',
                  value: 'abdominalCurl'
                },
                {
                  label: '800米跑（分·秒）',
                  value: 'meterRun800'
                }
              )
            }
          }
        })
        break
    }
    return localColumns
  }
}



// WEBPACK FOOTER //
// ./src/components/common/student-status-card/components/StatusCard/components/StatusCard.js